import React from 'react';
import ReactDOM from 'react-dom/client';

import '@localization/i18n';
import { ErrorBoundary } from '@components/ErrorBoundary';
import { BrowserRouter } from 'react-router-dom';
import { Providers } from './Providers';
import App from './App';
import { SiteConfig } from './utils/SiteConfig';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

(async () => {
  await SiteConfig.init();

  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <Providers>
          <BrowserRouter
            // Suppressing React Router future flags warnings
            future={{ v7_startTransition: false, v7_relativeSplatPath: false }}
          >
            <App />
          </BrowserRouter>
        </Providers>
      </ErrorBoundary>
    </React.StrictMode>,
  );
})();
